import React from 'react';
import { ProductTitle as StyledProductTitle } from './ProductTitle.styled';

export interface ProductTitleProps {
  children: React.ReactNode;
}

export function ProductTitle({ children }: ProductTitleProps) {
  return (
    <StyledProductTitle className='product-title'>
      {children}
    </StyledProductTitle>
  );
}
